import type { ReactNode } from "react";

import { LABEL_CLS } from "@/components/editorial";

const INK_58 = "text-[color-mix(in_srgb,var(--theme-ink)_58%,transparent)]";
const INK_72 = "text-[color-mix(in_srgb,var(--theme-ink)_72%,transparent)]";

/**
 * A product shot as a section stages it: one small label, the frame, and a
 * line under it saying what the frame shows. The frame is decorative to
 * assistive technology, so the shot's full text summary always reaches it.
 * With a caption, sighted readers get that one line and the summary is kept
 * for assistive technology alone; without one, the summary is the line. The
 * wrapper is the scope the shots' stylesheet applies within
 * (product-shot.css).
 */
export function ShotFigure({
  summary,
  caption,
  label = "Sample workspace",
  children,
}: {
  summary: ReactNode;
  /** One line for sighted readers in place of the summary. */
  caption?: ReactNode;
  label?: string;
  children: ReactNode;
}) {
  return (
    <div data-shot-scope="">
      <figure className="m-0 min-w-0">
        <p className={`${LABEL_CLS} ${INK_58} mb-4`}>{label}</p>
        {children}
        <figcaption className={`${INK_72} mt-4 max-w-[68ch] text-[0.84rem] leading-[1.55]`}>
          {caption ? (
            <>
              <span aria-hidden="true">{caption}</span>
              <span className="sr-only">{summary}</span>
            </>
          ) : (
            summary
          )}
        </figcaption>
      </figure>
    </div>
  );
}
